import { render, staticRenderFns } from "./MobileTable.vue?vue&type=template&id=10f405a2&scoped=true"
import script from "./MobileTable.vue?vue&type=script&lang=js"
export * from "./MobileTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f405a2",
  null
  
)

export default component.exports